import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
class SecondTime extends Component{
  render(){
    return (
      <ReactCSSTransitionGroup
        className="container result"
        component="div"
        transitionName="fade"
        transitionEnterTimeout={800}
        transitionLeaveTimeout={500}
        transitionAppear
        transitionAppearTimeout={500}
      >
        <div>
        <h2 style={{ fontSize: 45, textAlign: "center", color:"#444444" }}>
        受験は1度のみ可能です。
        </h2>
        </div>
      </ReactCSSTransitionGroup>
    );
  }
}

export default SecondTime;



// WEBPACK FOOTER //
// ./src/components/quiz/YouCannotTakeItTwice.js